import style from "./home.module.css";
import Button from "../../components/button/Button";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { configAction } from "../../store/config/slice";
import { GameStep, ModalStep } from "../../types/config";
import { updateUrlParams } from "../../helpers/url";
import Header from "../../components/header/Header";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import Information from "../../components/information/Information";
import FooterCo from "../../components/footer/FooterCo";
import BrandsSlide from "../../components/brands/BrandsSlider/BrandsSlide";
import useWebEngageCategoryViewed from "../../hooks/webengage/useWebEngageCategoryViewed";
import { useEffect } from "react";
import useWebEngageMyGiftClick from "../../hooks/webengage/useWebEngageMyGiftClick";
import useWebEngageGiveChanceClick from "../../hooks/webengage/useWebEngageGiveChanceClick";
const HomePage = () => {
  const dispatch = useAppDispatch();
  // const sendDataToGTM = useGTMDispatch();
  const { trackWebEngageMyGiftClick } = useWebEngageMyGiftClick();
  const { token } = useAppSelector((state) => state.config);
  const user = useAppSelector((state) => state.login.user);
  const chance = useAppSelector((state) => state.game.chnace);
  const userSpecialChance = useAppSelector(
    (state) => state.game.special_chance
  );
  const { trackWebEngageCategoryViewed } = useWebEngageCategoryViewed();
  const { tracWebEngageGiveChanceClick } = useWebEngageGiveChanceClick();

  const handleStartGame = function () {
    // sendDataToGTM({ event: " GardoonebaniShans1402-StartBtn" });
    if (!token) {
      dispatch(configAction.setModalStep(ModalStep.LOGIN));
    } else {
      if (chance === 0 && userSpecialChance === 0) {
        dispatch(configAction.setGameStep(GameStep.CHANCE));
      } else {
        dispatch(configAction.setGameStep(GameStep.CATEGORY));
      }
    }
  };
  const handleLogout = function () {
    dispatch(configAction.setModalStep(ModalStep.LOGOUT));
  };
  const handleBanibonPage = function () {
    dispatch(configAction.setGameStep(GameStep.BANIBON));
    updateUrlParams({ page: "banibon" });
    trackWebEngageMyGiftClick();
  };
  const handleShare = function () {
    dispatch(configAction.setGameStep(GameStep.CHANCE));
    updateUrlParams({ page: "chance" });
    tracWebEngageGiveChanceClick();
  };
  const handleRule = function () {
    dispatch(configAction.setModalStep(ModalStep.RULE));
  };

  useEffect(() => {
    trackWebEngageCategoryViewed({ categoryName: "banichance_s1404" });
  }, [trackWebEngageCategoryViewed]);

  return (
    <div className={style.home}>
      <div className={style["rule-head"]}>
        <Header className="desktop" logo />
        <div onClick={handleRule} className={`${style.rule} desktop`}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/icon/rule.svg`}
            alt=""
            className="hover"
          />
          <span className="desktop">راهنمای بازی</span>
        </div>
      </div>
      <div className={style.inner}>
        <div className={`${style["content-row"]} desktop`}>
          <Button
            arrow
            onclick={handleStartGame}
            text="ورود به بازی"
            className="hover"
          />
          {token && (
            <div className={style["auth-btn"]}>
              <Button
                onclick={handleShare}
                text="دریافت شانس"
                outlline
                className="hover"
              />
              <Button
                onclick={handleBanibonPage}
                text="جوایز من"
                outlline
                className="hover"
              />
            </div>
          )}
          <BrandsSlide />
        </div>
        <div className={`${style["hero-row"]} mobile`}>
          <div className={style.rule}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/rule.svg`}
              alt=""
              onClick={handleRule}
            />
          </div>
          <div className={style.hero}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/image/wheel.png?t=14031116`}
              alt=""
              style={{ width: 224, height: 135 }}
            />
          </div>
        </div>
        <div className={style["content-row"]}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/image/logo-desk.png?t=14031116`}
            alt=""
            className="desktop"
          />
          <div className={style.greeting}>
            <span className={style["greeting-title"]}>
              به بانی‌شانس خوش اومدی!
            </span>
            <div className="flex w-full flex-col justify-center items-center">
              <span className={style["greeting-desc"]}>
                کد تخفیف 100% و کلی جایزه دیگه منتظرته!
              </span>
            </div>
          </div>
          <Information />
          {token && (
            <div className={style.logout}>
              <div className={style["logout-phone"]}>
                <span>با شماره {user.data?.data?.mobile} وارد شدی</span>
              </div>

              <button
                className={`${style["logout-change"]} hover`}
                onClick={handleLogout}
              >
                <span>خروج</span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/icon/exit.svg`}
                  alt=""
                />
              </button>
            </div>
          )}
          <div className={`${style["content-row"]} mobile`}>
            <Button
              arrow
              onclick={handleStartGame}
              text="ورود به بازی"
              className="hover"
            />
            {token && (
              <div className={style["auth-btn"]}>
                <Button
                  onclick={handleShare}
                  text="دریافت شانس"
                  outlline
                  className="hover"
                />
                <Button
                  onclick={handleBanibonPage}
                  text="جوایز من"
                  outlline
                  className="hover"
                />
              </div>
            )}
            <BrandsSlide />
          </div>
        </div>
      </div>
      <FooterCo />
    </div>
  );
};
export default HomePage;
